export const NAMESPACE = "HeaderBarModule";
export const FORM_ID = "FormHeaderBarModule";
export const EVENT_SWITCHER_DROPDOWN_ID = "EventSwitcherDropdown";
export const PROFILE_DROPDOWN = "ProfileDropdown";
